export default "__VITE_ASSET__B8gbYN6e__"